import { FC } from 'react';
import { Box } from '@chakra-ui/react';

import { TransactionStatus } from '__generated__/GQL';
import { formatAmount } from 'common/formatAmount';
import Text from 'components/_core/Text';
import { getSignForTransaction } from 'features/Bank/pages/Overview/utils/getSignForTransaction';

type TransactionAmountProps = {
  transaction: {
    status: TransactionStatus;
    type: string;
    currency: string;
    value: number;
    fee?: number;
  };
};

const TransactionAmount: FC<TransactionAmountProps> = ({ transaction }) => {
  const { currency, fee, status, type } = transaction;
  const sign = getSignForTransaction({ transaction });

  return (
    <Box textAlign="right">
      <Text
        color={(() => {
          if (status === TransactionStatus.Pending) {
            return 'text-discreet';
          }

          return type === 'payin' ? 'green.600' : 'text-primary';
        })()}
        fontWeight="weight-500"
        textDecoration={
          status === TransactionStatus.Canceled ? 'line-through' : 'inherit'
        }
        whiteSpace="nowrap"
      >
        {`${sign} ${formatAmount({
          ...transaction,
          forcePlusSign: false,
        })}`}
      </Text>

      {fee ? (
        <Text size="sm" variant="light">{`(${formatAmount({
          currency,
          value: -fee,
        })})`}</Text>
      ) : null}
    </Box>
  );
};

export default TransactionAmount;
